// eslint-disable-next-line import/prefer-default-export
export const handleInputEvent = (field, handlerFunc) => (
  value => handlerFunc({ target: { name: field.name, value } })
);
